export const DAYS_ALLOWED_REFUND_AFTER_SUBMISSION = 30
export const REFUND_BUTTON_TOOLTIP_TEXT = `Refunds may be issued within ${DAYS_ALLOWED_REFUND_AFTER_SUBMISSION} days after submission.`
export const PaymentMethod = {
  REGGORA_DIRECT: 'reggora_direct',
  LENDER_DIRECT: 'lender_direct',
}
